import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign"; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      uid: 0,
      modals: []
    };
  },
  created: function created() {
    this.$modal._setDynamicContainer(this);
  },
  methods: {
    add: function add(modal, params, config) {
      var _this = this;

      var id = this.uid++;
      config = config ? Object.assign({}, config) : {};

      if (!config.name) {
        config.name = '_dynamic-modal-' + id;
      }

      this.modals.push({
        id: id,
        component: modal,
        params: params || {},
        config: config
      });
      this.$nextTick(function () {
        _this.$modal.show(config.name);
      });
    },
    remove: function remove(id) {
      for (var i in this.modals) {
        if (this.modals[i].id === id) {
          this.modals.splice(i, 1);
          return;
        }
      }
    }
  }
};